import React, { useState, useEffect, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import { getBintiCaseNotes, getBintiCaseNotesForUAP } from "../services/soar";

function CaseNoteDisplay({ application, caseNoteId, label, caseNoteDate }) {
  const isMountedRef = useRef(true);
  const [notes, setNotes] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    return () => (isMountedRef.current = false);
  }, []);

  const handleToggleModal = async (newIsOpen) => {
    setIsOpen(newIsOpen);

    if (!newIsOpen || !application?.id) {
      return;
    }

    setLoaded(false);

    if (application.HomeData[0].noLicenseId === "1") {
      console.log("App ID", application.id, caseNoteId);
      const response = await getBintiCaseNotes(
        application.HomeData[0].company,
        "1",
        application.id,
        "null"
      );
      if (!isMountedRef.current) {
        return;
      }

      if (response) {
        const data = JSON.parse(response).casenotes.filter(
          (note) => note.id === caseNoteId
        );
        console.log("App Case Note", data);
        setNotes(data);
      }

      setLoaded(true);
    } else {
      const applicantId = application.HomeData[0].members.filter(
        (m) => m.primarycontact === "Yes"
      )[0]?.contactid;
      console.log("UAP", applicantId, caseNoteId);
      const response = await getBintiCaseNotesForUAP(applicantId);
      if (!isMountedRef.current) {
        return;
      }

      if (response) {
        const data = JSON.parse(response).casenotes.filter(
          (note) => note.id === caseNoteId
        );
        console.log("UAP Case Note", data);
        setNotes(data);
      }

      setLoaded(true);
    }
  };
  return (
    <>
      {loaded ? (
        <Modal
          size="lg"
          show={isOpen}
          animation={false}
          onHide={() => setIsOpen(false)}
        >
          <Modal.Header closeButton className="bg-info text-white">
            <Modal.Title>
              {`Case Note for ${application.HomeData[0].fostercarehomename}`}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-2">
              <div className="col-3">
                {notes.length > 0 &&
                notes[0]["case-note-type"] !== "next_planned_contact"
                  ? "Case Note Date:"
                  : "Next Planned Date:"}
              </div>
              <div className="col-3 font-weight-bold">
                {notes.length > 0 &&
                  new Date(
                    notes[0]["date"].replaceAll("-", "/")
                  ).toLocaleDateString()}
              </div>
              <div className="col-3">Created On:</div>
              <div className="col-3 font-weight-bold">
                {notes.length > 0 &&
                  new Date(notes[0]["created-at"]).toLocaleDateString()}
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-3">Type</div>
              <div className="col-3 font-weight-bold">
                {notes.length > 0 &&
                  notes[0]["case-note-type"].replaceAll("_", " ")}
              </div>
              <div className="col-3">Contact Method</div>
              <div className="col-3 font-weight-bold">
                {notes.length > 0 &&
                  notes[0]["contact-method"] &&
                  notes[0]["contact-method"].replaceAll("_", " ")}
              </div>
            </div>
            <div className="row">
              <div className="col border bg-light p-2 m-2">
                {notes.length > 0 && notes[0]["case-note-body"]}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : null}
      <div
        className="btn btn-light border mb-1"
        brole="button"
        onClick={() => {
          handleToggleModal(!isOpen);
        }}
      >
        {`${label} ${new Date(
          caseNoteDate.replaceAll("-", "/")
        ).toLocaleDateString()}`}
      </div>
    </>
  );
}

export default CaseNoteDisplay;
